export const  translationMenuManagement = (props) => {
  return {
    title: props.t("menu.label.fastfood.menu.management.title"),
    create: props.t("label.actions.create"),
    save: props.t("config-ifood.modal.save"),
    edit: props.t("label.actions.edit"),
    subtitle: props.t("menu.label.fastfood.menu.management.subtitle"),
    spinner: props.t("menu.label.fastfood.menu.management.spinner"),
    placeholder: props.t(
      "menu.label.fastfood.menu.management.company.placeholder"
    ),
    error: props.t("menu.label.fastfood.menu.management.company.error"),
    description: props.t(
      "menu.label.fastfood.menu.management.company.description"
    ),
    companyCreate: props.t(
      "menu.label.fastfood.menu.management.company.create"
    ),
    notFound: props.t("menu.label.fastfood.menu.management.company.notFound"),
    select: props.t("menu.label.fastfood.menu.management.company.select"),
    modalTitle: props.t(
      "menu.label.fastfood.menu.management.company.modal.title"
    ),
    modalMessage: props.t(
      "menu.label.fastfood.menu.management.company.modal.message"
    ),
    modalWarning: props.t(
      "menu.label.fastfood.menu.management.company.modal.warning"
    ),
    modalConfirmButton: props.t(
      "menu.label.fastfood.menu.management.company.modal.button.yes"
    ),
    modalCancelButton: props.t(
      "menu.label.fastfood.menu.management.company.modal.button.cancel"
    ),
    confirmDelete: props.t(
      "menu.label.fastfood.menu.management.company.modal.dialog.confirmDelete"
    ),
    dialogError: props.t(
      "menu.label.fastfood.menu.management.company.modal.dialog.error"
    ),
    confirmSuccess: props.t(
      "menu.label.fastfood.menu.management.company.modal.dialog.confirmSuccess"
    ),
    saveError: props.t("menu.label.fastfood.menu.management.company.modal.dialog.save.error")
  }
}